// extracted by mini-css-extract-plugin
module.exports = {"container":"m_c","background":"m_m"};